import { useContext, type ComponentProps } from "react";
import { FloatingPortal } from "@floating-ui/react";
import { InteractionBlockContext } from "../system/interactionBlock";

/** Messbarer Offset-Parent für alle Body-/Container-Portale. So rechnet Floating UI
 * Viewport-Pixel genau einmal in das CSS-Zoom-Koordinatensystem der App um. */
export function FloatingLayer({ children, ...props }: ComponentProps<typeof FloatingPortal>) {
  const blocked = useContext(InteractionBlockContext);
  if (blocked) return null;
  return <FloatingPortal {...props}><div className="ck-overlay-positioner">{children}</div></FloatingPortal>;
}
